export default __webpack_public_path__ + "assets/unification-dark.7f192f3d.svg";